import { ApiResponse } from '@ustra/data/src/models/api-model'
import { HttpMethod } from '@ustra/core/src/server/http/const'
import { UtraService } from '@ustra/nuxt/src/services/ustra-service'

export interface AppProp {
  companyName: string
  systemName: string
  systemAliasName: string
  pageSize: number
  sysGbcd: string
  checkDuplication: boolean
  maximumLoginFailNumbers: number
  passwordChangeDays: number
}

export interface InitialData {
  appProp: AppProp
  deviceId: string
}

export class InitialDataService extends UtraService {
  async getInitialData() {
    const result = await this.$ustra.api.call<ApiResponse<InitialData>>({
      url: '/api/system/initializing-data.json',
      method: HttpMethod.POST,
      data: {},
    })

    return result.data.body
  }
}

export const initialDataService = new InitialDataService()
export default initialDataService
